import { set } from 'lodash';
import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import RadioCard from 'pages/signup/components/radioCard';
import React, { useEffect, useState, useSyncExternalStore } from 'react';
import { Col, Row, Tabs, Tab, Card, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Loader from 'shared/common/loader';
import { userStore } from 'store/UserStore';
import UserHttp from '../services/profile.service';

const SummaryInfo = () => {
  const [selectedMonth, setSelectedMonth] = useState('');
  //   const [selectedEndMonth, setSelectedEndMonth] = useState('');
  //   const [selectedYear, setSelectedYear] = useState('');
  //   const [selectedEndYear, setSelectedEndYear] = useState('');
  //   const [startDate, setStartDate] = useState('');
  //   const [endDate, setEndDate] = useState('');
  const [customer] = userStore((state: any) => [state.customer]);
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState('dates');
  const initialStateFilter = {
    pan: customer?.kyc?.pan?.value,
    fromDate: '',
    toDate: '',
  };
  const [filter, setFilter] = useState<any>(initialStateFilter);
  //   const months = [
  //     'January',
  //     'February',
  //     'March',
  //     'April',
  //     'May',
  //     'June',
  //     'July',
  //     'August',
  //     'September',
  //     'October',
  //     'November',
  //     'December',
  //   ];

  //   const currentYear = new Date().getFullYear() - 2;
  //   const years = Array.from({ length: 10 }, (_, index) =>
  //     String(currentYear + index)
  //   );

  // const handleMonthChange = (event) => {
  //   const monthValue = event.target.value;
  //   setSelectedMonth(monthValue);
  //   sendPayload(monthValue, selectedYear);
  // };
  //   const handleEndMonthChange = (event) => {
  //     const monthValue = event.target.value;
  //     setSelectedEndMonth(monthValue);
  //     sendEndPayload(monthValue, selectedEndYear);
  //   };

  const handleYearChange = (event) => {
    const yearValue = event.target.value;
    // setSelectedYear(yearValue);
    // sendPayload(selectedMonth, yearValue);
  };
  //   const handleEndYearChange = (event) => {
  //     const yearValue = event.target.value;
  //     setSelectedEndYear(yearValue);
  //     sendEndPayload(selectedEndMonth, yearValue);
  //   };

  //   const sendPayload = (month, year) => {
  //     if (month && year) {
  //       const monthMap = {
  //         January: '01',
  //         February: '02',
  //         March: '03',
  //         April: '04',
  //         May: '05',
  //         June: '06',
  //         July: '07',
  //         August: '08',
  //         September: '09',
  //         October: '10',
  //         November: '11',
  //         December: '12',
  //       };

  //       const day = '01';
  //       const hour = '14';
  //       const minute = '30';
  //       const second = '55';
  //       const timezoneOffset = '+05:30';

  //       var formattedDate = `${year}-${monthMap[month]}-${day}T${hour}:${minute}:${second}${timezoneOffset}`;
  //       console.log('Payload:', formattedDate);
  //       setStartDate(formattedDate);

  //       // You can use the formattedDate in your payload or perform any other action
  //     }
  //   };
  //   const sendEndPayload = (month, year) => {
  //     if (month && year) {
  //       const monthMap = {
  //         January: '01',
  //         February: '02',
  //         March: '03',
  //         April: '04',
  //         May: '05',
  //         June: '06',
  //         July: '07',
  //         August: '08',
  //         September: '09',
  //         October: '10',
  //         November: '11',
  //         December: '12',
  //       };

  //       const day = '01';
  //       const hour = '14';
  //       const minute = '30';
  //       const second = '55';
  //       const timezoneOffset = '+05:30';

  //       // Use new Date(year, month, 0) to get the last day of the month
  //       const lastDay = new Date(year, monthMap[month], 0).getDate();
  //       var formattedDate2 = `${year}-${monthMap[month]}-${lastDay}T${hour}:${minute}:${second}${timezoneOffset}`;
  //       setEndDate(formattedDate2);
  //       console.log('Payload:', formattedDate2);
  //       // You can use the formattedDate in your payload or perform any other action
  //     }
  //   };
  //   console.log('formattedDate2', endDate > startDate);
  const handleChangeFilter = (e: any) => {
    const { name, value } = e.target;

    setFilter({
      ...filter,
      // [name]: name === 'fromDate' || name === 'toDate' ? moment(value).format('DD/MM/yyyy') : value
      [name]: value,
    });
  };

  const getSummaryReprts = async () => {
    try {
      setLoading(true);
      if (filter?.fromDate == '' || filter?.toDate == '') {
        setLoading(false);
        return toast.error('Please select date');
      } else if (
        filter?.fromDate > new Date().toISOString().split('T')[0] ||
        filter?.toDate > new Date().toISOString().split('T')[0]
      ) {
        setLoading(false);
        return toast.error("Date should be smaller than today's date");
      } else if (filter?.fromDate > filter?.toDate) {
        setLoading(false);
        return toast.error('From date should be smaller than To date');
      }
      const resp = await UserHttp.summaryReports(filter);
      if (resp?.status == 200) {
        setLoading(false);
        toast.success(resp?.data?.data?.msg);
        setFilter(initialStateFilter);
        setSelectedMonth('');
      }
    } catch (err) {
      setLoading(false);
      toast.error('Something went wrong');
      console.log('err', err);
    }
  };

  function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 because months are zero-indexed
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  function getDate30DaysBefore(days) {
    const currentDate = new Date();
    const pastDate = new Date(currentDate);
    pastDate.setDate(currentDate.getDate() - days);
    return pastDate;
  }
  function setDateFilter(days) {
    const currentDate = new Date();
    const formattedCurrentDate = formatDate(currentDate);
    const pastDate = getDate30DaysBefore(days);
    const formattedPastDate = formatDate(pastDate);

    setFilter({
      ...filter,
      fromDate: formattedPastDate,
      toDate: formattedCurrentDate,
    });
  }
  // useEffect(() => {
  //   const pastDate = getDate30DaysBefore(90);
  //   const currentDate = new Date();

  //   const formattedDate = formatDate(pastDate);
  //   const formattedcurrentDate = formatDate(currentDate);
  //   console.log('formattedDate', formattedDate, formattedcurrentDate);
  // }, []);

  return (
    <>
      {/*<Toast/>*/}
      {loading && <Loader />}
      <Card>
        <Card.Body className='p-5'>
          <div>
            <Card.Title>Account Summary</Card.Title>
            <Row className='mt-4'>
              <Col md={6}>
                {/* <RadioCard
                  label={'Select Dates'}
                  id={'date_selection'}
                  name='account_summary'
                  onChange={(e) => {
                    setFilterType(e.target.value);
                  }}
                  value={'dates'}
                  // disabled={isPanVerified}
                  checked={filterType == 'dates'}
                  style={{ fontSize: '14px' }}
                /> */}
                <Form.Check
                  type='radio'
                  label={'Select Dates'}
                  id={'date_selection'}
                  name='account_summary'
                  onChange={(e) => {
                    setFilterType(e.target.value);
                  }}
                  value={'dates'}
                  // disabled={isPanVerified}
                  checked={filterType == 'dates'}
                  // style={{ fontSize: '14px' }}
                />
              </Col>
              <Col md={6}>
                {/* <RadioCard
                  label={'Select Duration'}
                  id={'duration_selection'}
                  name='account_summary'
                  onChange={(e) => {
                    setFilterType(e.target.value);
                  }}
                  value={'duration'}
                  checked={filterType == 'duration'}
                  style={{ fontSize: '14px' }}

                  // disabled={isPanVerified}
                /> */}
                <Form.Check
                  type='radio'
                  label={'Select Duration'}
                  id={'duration_selection'}
                  name='account_summary'
                  onChange={(e) => {
                    setFilterType(e.target.value);
                  }}
                  value={'duration'}
                  checked={filterType == 'duration'}
                  // style={{ fontSize: '14px' }}

                  // disabled={isPanVerified}
                />
              </Col>
            </Row>
            {/* <Card className='mt-2'>
              <Card.Body> */}
            {filterType == 'dates' ? (
              <Row className='mt-4'>
                {/* <div className='m-2'>Start Date :</div> */}
                <Col md={6}>
                  <div>
                    {/* <label>Month:</label> */}
                    {/* <select
                    className='form-control'
                    value={selectedMonth}
                    onChange={handleMonthChange}
                  >
                    <option value=''>Select Month</option>
                    {months.map((month, index) => (
                      <option key={index} value={month}>
                        {month}
                      </option>
                    ))}
                  </select> */}
                    <Form.Group className='mb-3' controlId='orderType'>
                      <Form.Label>From Date</Form.Label>
                      <Form.Control
                        type='date'
                        name='fromDate'
                        onChange={(e) => handleChangeFilter(e)}
                        value={filter.fromDate}
                        max={new Date().toISOString().split('T')[0]}
                      ></Form.Control>
                    </Form.Group>
                  </div>
                </Col>

                <Col md={6}>
                  {/* <label>Year:</label> */}
                  {/* <select
                  className='form-control'
                  value={selectedYear}
                  onChange={handleYearChange}
                >
                  <option value=''>Select Year</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select> */}
                  <Form.Group className='mb-3' controlId='orderType'>
                    <Form.Label> To Date</Form.Label>
                    <Form.Control
                      type='date'
                      name='toDate'
                      onChange={(e) => handleChangeFilter(e)}
                      value={filter.toDate}
                      min={filter.fromDate}
                      max={new Date().toISOString().split('T')[0]}
                      disabled={filter.fromDate === ''}
                    ></Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            ) : (
              <Row className='mt-4'>
                {/* <div className='m-2'>Start Date :</div> */}
                <Col md={12}>
                  <div>
                    {/* <label>Month:</label> */}
                    {/* <select
                          defaultValue={selectedMonth}
                          onChange={(e) => {
                            setDateFilter(e.target.value);
                          }}
                          className='form-control'
                          style={{ padding: '5px', border: 'none' }}
                        >
                          <option value=''>Select Duration</option>
                          {[30, 60, 90].map((month, index) => (
                            <option key={index} value={month}>
                              {month} Days
                            </option>
                          ))}
                        </select> */}
                    <Form.Group controlId='orderMetal'>
                      {/* <Form.Label>Select Duration</Form.Label> */}
                      <Form.Select
                        onChange={(e) => {
                          setDateFilter(e.target.value);
                          setSelectedMonth(e.target.value);
                        }}
                        value={selectedMonth}
                        // defaultValue={selectedMonth}
                      >
                        <option value=''>Select Duration</option>
                        {[30, 60, 90].map((month, index) => (
                          <option key={index} value={month}>
                            {month} Days
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>
                </Col>
              </Row>
            )}
            {/* </Card.Body>
            </Card> */}

            {/* <Row>
              <div className='m-2'>End Date :</div>
              <Col md={6}>
                <div className=''>
                  <select
                    className='form-control '
                    value={selectedEndMonth}
                    onChange={handleEndMonthChange}
                  >
                    <option value=''>Select Month</option>
                    {months.map((month, index) => (
                      <option key={index} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>

              <Col md={6}>
                <select
                  className='form-control'
                  value={selectedEndYear}
                  onChange={handleEndYearChange}
                >
                  <option value=''>Select Year</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </Col>
            </Row> */}
            <Row className='mt-4'>
              <Button
                className='btn w-25 m-auto'
                onClick={() => getSummaryReprts()}
              >
                Generate Summary
              </Button>
            </Row>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default SummaryInfo;
